import React from "react";

import {
  FormControlLabel,
  FormControlLabelProps,
  Typography,
} from "@mui/material";

import Checkbox from "@rui/Checkbox";
import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";
import Stack from "@rui/Stack";

type DeleteWorkspaceWordConfirmationModalProps = ConfirmationModalProps & {
  confirmationDismissed: boolean;
  onDismissConfirmation: FormControlLabelProps["onChange"];
};

const DeleteWorkspaceWordConfirmationModal = ({
  confirmationDismissed,
  onDismissConfirmation,
  ...modalProps
}: DeleteWorkspaceWordConfirmationModalProps) => {
  return (
    <ConfirmationModal
      title="Delete word from Workspace?"
      size="md"
      {...modalProps}
      confirmProps={{
        type: "negative",
        label: "Delete word",
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="bodyPrimaryReg" color="shades.neutral.600">
          When you remove custom vocabulary, it is removed for everyone in your
          Workspace.
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={confirmationDismissed} />}
          onChange={onDismissConfirmation}
          label={
            <Typography variant="bodySecondaryReg" color="shades.neutral.600">
              Don't show this again
            </Typography>
          }
          sx={{ marginLeft: 0 }}
        />
      </Stack>
    </ConfirmationModal>
  );
};

export default DeleteWorkspaceWordConfirmationModal;
